import {
	AdditionalRequirement,
	ContainerSizeEnum,
	PriceCalculatorTransportType,
} from '@uturn/api/v1';
import { z } from '@uturn/portal/zod';
import { formValidationMessage } from '@uturn/portal/zod/utils';

const locationSchema = z
	.object({
		id: z.number().optional(),
		googlePlaceId: z.string().optional(),
		name: z.string().nullish(),
		street: z.string().nullish(),
		city: z.string().nullish(),
		postalCode: z.string().nullish(),
		countryCode: z.string().nullish(),
		latitude: z.number().nullish(),
		longitude: z.number().nullish(),
		houseNumber: z.string().nullish(),
	})
	.refine(
		(location) =>
			location.id !== undefined || location.googlePlaceId !== undefined,
		formValidationMessage('location_select_from_suggestions'),
	);

export const priceRequestSchema = z.object({
	transportType: z.nativeEnum(PriceCalculatorTransportType),
	containerSize: z.nativeEnum(ContainerSizeEnum),
	additionalRequirement: z.nativeEnum(AdditionalRequirement),
	locations: z.array(locationSchema),
});

export type PriceRequestFormFields = z.infer<typeof priceRequestSchema>;
export type LocationField = z.infer<typeof locationSchema>;
